import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import MyApi, { baseURL } from './MyApi';
import { t } from 'i18next';



class DAByTbStats extends Component {

  constructor(props) {
    super(props);
    // N’appelez pas `this.setState()` ici !
    this.state = {
      dataYears: [],
      data: []
    };
    

  }



  componentDidMount() {
    this.DefaultLineChart();
  }



  DefaultLineChart = async () => {
    try {
      
      MyApi.get('/getAllYearDepenseSimple').then(result => {
        const res = result.data;
        this.setState({ dataYears: res});
      });

      const response = await fetch(baseURL +'/getDepenseAnnuelAllYearByTb/' + this.props.currentLanguageCode +'/'+ this.props.tb);
      const jsonData = await response.json();
      this.setState({ data: jsonData });
    } catch (err) {
      console.error(err.message);
    }
  }




  render() {

    Highcharts.setOptions({
      lang: {
        viewData: t('viewData'),
        hideData: t('hideData'),
        viewFullscreen: t('viewFullscreen'),
        exitFullscreen: t('exitFullscreen'),
        exportData: {
          categoryHeader: t('annee')
        } ,
        }
    });

    let option = {
      exporting:{
        buttons:{
          contextButton:{
            menuItems:['viewFullscreen','printChart','viewData','separator','downloadPNG','downloadJPEG','downloadPDF','downloadSVG','separator','downloadXLS','downloadCSV']
          }
        },
        menuItemDefinitions: {
        
          "printChart": {text: t('printChart')},
          "downloadPNG": {text: t('downloadPNG')},
          "downloadJPEG": {text: t('downloadJPEG')},
          "downloadPDF": {text: t('downloadPDF')},
          "downloadSVG": {text: t('downloadSVG')},
          "downloadXLS": {text: t('downloadXLS')},
          "downloadCSV": {text: t('downloadCSV')}
          }
      },
      accessibility: {
        enabled: false
      },
      chart: {
        type: this.props.typeChart
      },
      title: {
        text: t('TGDBD') + ' [ ' +this.props.article + ' -- ' + this.props.reference + ' ] ',
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        }
      },
     
      xAxis: {
        categories: this.state.dataYears,
        reversed: this.props.currentLanguageCode === 'ar' ? true : false
      },
      yAxis: {
        title: {
          text: t('montant'),
          style: {
            fontSize: '18px',
            fontWeight: 'bold'
          }
        },

        labels: {
          format: '{value}',
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0);
          }
        },
        opposite: this.props.currentLanguageCode === 'ar' ? true : false
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f}',
          },
          enableMouseTracking: true
        }
      },
      tooltip: {
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        },
        pointFormat: '{series.name}: {point.y}'
      },
      series: this.state.data
    }


    return (




      <div className="col-md-12 ">



        <HighchartsReact highcharts={Highcharts} options={option} />




      </div>


    );
  }
}
export default DAByTbStats;
